{
  "de": {
    "pinboard": {
      "activity": {
        "board": {
          "addAttachment": "<strong>{user}</strong> hat der Karte <a href=\"{cardUrl}\">{cardName}</a> den Anhang <a href=\"{url}\" target=\"_blank\">{value}</a> hinzugefügt",
          "addAttachmentAfterRemoval": "<strong>{user}</strong> hat den Anhang {value} der Karte <a href=\"{cardUrl}\">{cardName}</a> hinzugefügt",
          "createCard": "<strong>{user}</strong> hat die Karte <a href=\"{cardUrl}\">{cardName}</a> erstellt",
          "destroyCard": "<strong>{user}</strong> hat die Karte <em>{cardName}</em> gelöscht",
          "moveCard": "<strong>{user}</strong> hat die Karte <a href=\"{cardUrl}\">{cardName}</a> von <em>{oldValue}</em> zu <em>{value}</em> verschoben",
          "removeAttachment": "<strong>{user}</strong> hat den Anhang <em>{oldValue}</em> der Karte <a href=\"{cardUrl}\">{cardName}</a> entfernt",
          "updateCardColor": "<strong>{user}</strong> hat die Farbe der Karte geändert\"",
          "updateCardCoverImage": "<strong>{user}</strong> hat das Vorschaubild der Karte <a href=\"{cardUrl}\">{cardName}</a> auf <a href=\"{url}\" target=\"_blank\">{value}</a> geändert",
          "updateCardDescription": "<strong>{user}</strong> hat die Beschreibung der Karte <a href=\"{cardUrl}\">{cardName}</a> geändert\"",
          "updateCardName": "<strong>{user}</strong> hat den Namen der Karte <a href=\"{cardUrl}\">{cardName}</a> (von: <em>{oldValue}</em>) geändert",
          "updateCardVisitorPermissions": "<strong>{user}</strong> hat die Besucher*innen-Berechtigung der Karte <a href=\"{cardUrl}\">{cardName}</a> geändert (von: <em>{oldValue}</em>)"
        },
        "card": {
          "addAttachment": "<strong>{user}</strong> hat den Anhang <a href=\"{url}\" target=\"_blank\">{value}</a> hinzugefügt",
          "addAttachmentAfterRemoval": "<strong>{user}</strong> hat den Anhang {value} hinzugefügt",
          "createCard": "<strong>{user}</strong> hat diese Karte erstellt",
          "moveCard": "<strong>{user}</strong> hat diese Karte von <em>{oldValue}</em> zu <em>{value}</em> verschoben",
          "removeAttachment": "<strong>{user}</strong> hat den Anhang <em>{oldValue}</em> entfernt",
          "updateCardColor": "<strong>{user}</strong> hat die Farbe der Karte geändert",
          "updateCardCoverImage": "<strong>{user}</strong> hat das Vorschaubild auf <a href=\"{url}\" target=\"_blank\">{value}</a> geändert",
          "updateCardDescription": "<strong>{user}</strong> hat die Beschreibung der Karte geändert",
          "updateCardName": "<strong>{user}</strong> hat den Namen der Karte (von: <em>{oldValue}</em>) geändert",
          "updateCardVisitorPermissions": "<strong>{user}</strong> hat die Besucher*innen-Berechtigung der Karte geändert (von: <em>{oldValue}</em>)"
        },
        "missingUser": "Gelöschter User"
      },
      "buttons": {
        "addAttachment": "Hinzufügen",
        "addCard": "Karte hinzufügen",
        "addList": "Liste hinzufügen",
        "color": "Farbe",
        "create": "Anlegen",
        "loadMore": "Mehr laden",
        "openListSettings": "Listeneinstellungen öffnen"
      },
      "card": {
        "openFile": "Datei öffnen",
        "openLink": "Link öffnen",
        "setCoverAttachment": "Diesen Anhang als Vorschaubild verwenden"
      },
      "colorPalette": {
        "colorDropdown": "Farbpalette"
      },
      "confirm": {
        "deleteAttachment": {
          "text": "Diese Aktion kann nicht rückgängig gemacht werden. Der Anhang wird dauerhaft von der Karte entfernt.",
          "title": "Anhang löschen?"
        },
        "deleteCard": {
          "text": "Diese Aktion kann nicht rückgängig gemacht werden. Alle Inhalte der Karte werden dauerhaft entfernt.",
          "title": "Karte löschen?"
        },
        "deleteComment": {
          "text": "Diese Aktion kann nicht rückgängig gemacht werden. Der Kommentar wird dauerhaft von der Karte entfernt.",
          "title": "Kommentar löschen?"
        },
        "deleteList": {
          "text": "Diese Aktion kann nicht rückgängig gemacht werden. Die Liste wird mit allen enthaltenen Karten dauerhaft gelöscht.",
          "title": "Liste löschen?"
        },
        "removeMember": {
          "text": "Das Mitglied verliert den Zugriff auf diese Pinnwand und ihre Karten.",
          "title": "Mitglied entfernen?"
        }
      },
      "errors": {
        "boardUpdateFailed": "Fehler beim Aktualisieren des Boards",
        "cardLimitReached": "Du kannst maximal {limit} Karten in dieser Liste anlegen.",
        "listLimitReached": "Du kannst maximal {limit} Listen auf dieser Pinnwand anlegen."
      },
      "flash": {
        "attachmentDeleted": "Anhang entfernt",
        "boardUpdated": "Pinnwand aktualisiert",
        "cardNotFound": "Karte nicht gefunden",
        "colorUpdated": "Farbe aktualisiert",
        "commentDeleted": "Kommentar gelöscht",
        "commentUpdated": "Kommentar aktualisiert",
        "coverImageUpdated": "Vorschaubild aktualisiert",
        "descriptionUpdated": "Beschreibung aktualisiert",
        "linkAdded": "Link hinzugefügt",
        "listRemoved": "Liste entfernt",
        "memberRemoved": "Mitglied entfernt",
        "permissionsUpdated": "Berechtigungen aktualisiert",
        "titleUpdated": "Titel aktualisiert"
      },
      "headers": {
        "activities": "Aktivitäten",
        "attachFile": "Datei anhängen",
        "attachLink": "Link anhängen",
        "members": "Mitglieder",
        "permissions": "Berechtigungen",
        "pickColor": "Farbe auswählen",
        "visitorPermissions": "Besucher*innen dürfen..."
      },
      "labels": {
        "activity": "Aktivität",
        "attachments": "Anhänge",
        "cardTitle": "Kartentitel",
        "inList": "in {listName}",
        "visitorCanAddCards": "Karten löschen und hinzufügen",
        "visitorCanAddList": "Listen löschen und hinzufügen",
        "visitorCanComment": "In Karten kommentieren",
        "visitorCanViewActivities": "Aktivitätenverlauf der Karten sehen"
      },
      "links": {
        "activities": "Aktivitäten",
        "boardMembers": "Mitglieder",
        "imageSearch": "Bildersuche"
      },
      "paragraphs": {
        "addMembers": "Lade Mitglieder zu deiner Pinnwand ein, um mit ihnen zusammen die Pinnwand zu verwalten. Dafür ist ein fobizz-Konto notwendig.",
        "noMembers": "Du hast noch keine weiteren Mitglieder zu dieser Pinnwand eingelanden.",
        "noMoreActivities": "Keine weiteren Aktivitäten"
      },
      "placeholders": {
        "cardName": "Name für Karte eingeben...",
        "comment": "Kommentar hier eingeben...",
        "description": "Beschreibung hier eingeben...",
        "link": "URL hier eingeben...",
        "listName": "Name für Liste eingeben...",
        "searchImages": "Suchbegriff oder Farbe eingeben..."
      },
      "toolName": "Pinnwand",
      "visitorPermissions": {
        "cardDescription": {
          "visitor_permissions_invisible": "Besucher*innen können die Karte nicht sehen.",
          "visitor_permissions_read": "Besucher*innen können die Karte sehen.",
          "visitor_permissions_write": "Besucher*innen können die Karte bearbeiten."
        },
        "listDescription": {
          "visitor_permissions_invisible": "Besucher*innen können die Liste nicht sehen.",
          "visitor_permissions_read": "Besucher*innen können die Liste sehen.",
          "visitor_permissions_write": "Besucher*innen können Karten hinzufügen"
        },
        "permissions": "Besucher*innen-Berechtigung"
      }
    }
  }
}
